import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { AddQueueToPrinterAction, PrinterStoreState, RemoveQueueFromPrinterAction } from '../printer.types';

const initialState: PrinterStoreState = {
    queues:[]
}

export const printerSlice = createSlice({
    name:'printer',
    initialState,
    reducers:{
        addQueueToPrinter:(state, action:PayloadAction<AddQueueToPrinterAction>) => {
            state.queues.push(action.payload.queue);
        },
        removeQueueFromPrinter:(state, action:PayloadAction<RemoveQueueFromPrinterAction>) => {
            state.queues = state.queues.filter(queue => queue.id !== action.payload.id);
        } 
    }
});

export const {addQueueToPrinter, removeQueueFromPrinter}  = printerSlice.actions;
export const printerReducer = printerSlice.reducer;